import { BMEventsType, type InteractionPerformanceEventConfig } from '../types';

export const isInteractionConfig = (data: any): data is InteractionPerformanceEventConfig => {
	return data.type === BMEventsType.INLINE_RESULT;
};
